<h2 mat-dialog-title>{{ data.title || 'Notice' }}</h2>

<mat-dialog-content>
  @if (data.message === PDE_EULA_SYM) {
    <div [innerHTML]="pde_eula_content()"></div>
  } @else if (isTemplateRef(data.message)) {
    <ng-container *ngTemplateOutlet="data.message; context: data.data"></ng-container>
  } @else {
    <div>{{ data.message }}</div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (data.showCancel) {
    <button mat-button (click)="onCancel()">
      {{ data.cancelButtonText || 'Cancel' }}
    </button>
  }
  <button matButton="elevated" color="primary" (click)="onConfirm()">
    {{ data.confirmButtonText || 'OK' }}
  </button>
</mat-dialog-actions>
